import { type FC } from 'react';
import { createRoot } from 'react-dom/client';
import { AppBootstrap } from './AppBootstrap';
import { PublicChatbotRuntimeProvider } from './PublicChatbotRuntimeProvider';

const App: FC = () => {
  return (
    <PublicChatbotRuntimeProvider>
      <AppBootstrap />
    </PublicChatbotRuntimeProvider>
  );
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.self !== window.top) return;

  const rootElement = document.getElementById('react-app-root');

  if (rootElement) {
    // Add data attribute for scoped CSS styles
    rootElement.setAttribute('data-modern-ui-react', '');
    createRoot(rootElement).render(<App />);
  }
});
